import { create } from "zustand";
import { persist } from "zustand/middleware";

type PatchInfo = {
    patch: string;
    patchVideo: string;
};

type State = {
    hardCounterChampionDB: any[];
    championDB: any[];
    patchVersion: string;
    defaultComps: any[];
    patchInfo: PatchInfo;
};


type Actions = {
    setHardCounterChampionDB: (hardCounterChampionDB: any[]) => void;
    setChampionDB: (championDB: any[]) => void;
    setPatchVersion: (patchVersion: string) => void;
    setDefaultComps: (defaultComps: any[]) => void;
    setPatchInfo: (patchInfo: PatchInfo) => void;
};

export const usePatchStore = create<State & Actions>()(
    persist(
        (set) => ({
            hardCounterChampionDB: [],
            championDB: [],
            patchVersion: "",
            defaultComps: [],
            patchInfo: {
                patch: "",
                patchVideo: "",
            },

            setPatchInfo: (patchInfo: PatchInfo) =>
                set({ patchInfo }),

            setDefaultComps: (defaultComps: any[]) =>
                set({ defaultComps }),

            setHardCounterChampionDB: (hardCounterChampionDB: any[]) =>
                set({ hardCounterChampionDB }),

            setChampionDB: (championDB: any[]) =>
                set({ championDB }),

            setPatchVersion: (patchVersion: string) =>
                set({ patchVersion }),
        }),
        {
            name: "patch-ecosystem-store",
        }
    )
); 